// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2086":"css/admin-app.6689","5562":"css/app.6689"}[chunkId] + ".css";
};